import { Box, Flex } from '@/ui';
import { ACCENT, BAR } from './constants';

type Block = { top: number; height: number; left?: number; width?: number };

const COLUMNS: Block[][] = [
  [{ top: 10, height: 22 }],
  [
    { top: 18, height: 34, width: 48 },
    { top: 30, height: 30, left: 52, width: 48 },
  ],
  [
    { top: 6, height: 16 },
    { top: 58, height: 24 },
  ],
  [{ top: 40, height: 28 }],
];

export const DayColumnsThumbnail = () => (
  <Flex gap="3px" h="full" w="full">
    <Flex direction="column" gap="3px" pt="7px" w="6px">
      {Array.from({ length: 6 }).map((_, i) => (
        <Box
          bg={BAR}
          borderRadius="1px"
          h="2px"
          key={i}
          mb="auto"
          opacity={0.5}
        />
      ))}
    </Flex>
    {COLUMNS.map((blocks, i) => (
      <Flex direction="column" flex={1} gap="3px" key={i}>
        <Box bg={BAR} borderRadius="1px" flexShrink={0} h="4px" opacity={0.6} />
        <Box flex={1} position="relative">
          {blocks.map(({ top, height, left = 0, width = 100 }, j) => (
            <Box
              bg={i === 1 ? ACCENT : BAR}
              borderRadius="2px"
              h={`${height}%`}
              key={j}
              left={`${left}%`}
              opacity={i === 1 ? 0.55 : 0.35}
              position="absolute"
              top={`${top}%`}
              w={`${width}%`}
            />
          ))}
        </Box>
      </Flex>
    ))}
  </Flex>
);
